import { useNavigate } from 'react-router-dom';
import HeadersAuth from '../../components/base/HeadersAuth';

export default function SchwabComingSoon() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-purple-800 to-black text-white">
      <HeadersAuth />
      <div className="pt-[80px] min-h-screen flex items-center justify-center">
        <div className="bg-zinc-900 text-white p-6 rounded-xl shadow-xl w-full max-w-2xl text-center">
          
          {/* Schwab Logo */}
          <div className="mb-6">
            <div className="w-20 h-20 bg-blue-600 rounded-full mx-auto flex items-center justify-center mb-4">
              <svg className="w-12 h-12 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
              </svg>
            </div>
            <h1 className="text-3xl font-bold text-blue-400 mb-2">Schwab Integration</h1>
          </div>

          {/* Coming Soon Content */}
          <div className="mb-6">
            <h2 className="text-4xl font-bold text-purple-300 mb-3">Coming Soon!</h2>
            <p className="text-xl text-gray-300 mb-4">
              Schwab broker integration is currently under development
            </p>
            
            <div className="bg-blue-900/30 border border-blue-500 rounded-lg p-4">
              <h3 className="text-lg font-semibold text-blue-300 mb-2">Requirements (Coming Soon):</h3>
              <ul className="text-left space-y-1 text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mr-3"></span>
                  Minimum of Level 2 Options Approval
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mr-3"></span>
                  Active Margin Account
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mr-3"></span>
                  Thinkorswim by Schwab
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mr-3"></span>
                  Per Schwab policy, you must disconnect and reconnect your account every 7 days
                </li>
              </ul>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <button
              onClick={() => navigate('/broker-connect')}
              className="w-full p-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-semibold transition-colors"
            >
              ← Back to Broker Selection
            </button>
            
            <button
              onClick={() => navigate('/dashboard')}
              className="w-full p-3 bg-gray-600 hover:bg-gray-700 text-white rounded-lg font-semibold transition-colors"
            >
              Go to Dashboard
            </button>
          </div>

          {/* Progress Indicator */}
          <div className="mt-6">
            <div className="flex items-center justify-center space-x-2 mb-2">
              <div className="w-3 h-3 bg-purple-500 rounded-full animate-pulse"></div>
              <div className="w-3 h-3 bg-purple-500 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
              <div className="w-3 h-3 bg-purple-500 rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
            </div>
            <p className="text-sm text-gray-400">Development in progress...</p>
          </div>

        </div>
      </div>
    </div>
  );
} 